import React, { Component }  from 'react';

class LocateUs extends Component {
    render() {    
        //return <div dangerouslySetInnerHTML={{ __html: "<iframe src='https://www.youtube.com/embed/cWDJoK8zw58' />"}} />;   
        return <div dangerouslySetInnerHTML={{ __html: "<iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3580.2038890404283!2d-80.27065704847462!3d26.190044983362895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d905fb82c7e609%3A0xdeb2b94fadf60765!2s5396%20NW%2089th%20Ave%2C%20Sunrise%2C%20FL%2033351!5e0!3m2!1sen!2sus!4v1622593823713!5m2!1sen!2sus' width='100%' height='500' style='border:0;' allowfullscreen='' loading=lazy' />"}} />;   
    }    
}
export default LocateUs;